import React from 'react';
import { ArrowDownIcon, ArrowRightIcon } from 'lucide-react';
import { categoryLoop, systemPath, usageSteps } from '../data/content';
import { Eyebrow, Highlight, SectionLead, SectionTitle } from './ui/Section';
export function HowItWorks() {
  return <section className="mx-auto max-w-5xl px-4 py-12 md:py-16" data-id="element-146" data-mp="3q0kwyj3mrmlq">
      <Eyebrow data-id="element-147" data-mp="3u14vnr3uqy9z">🧭 How It Works</Eyebrow>
      <SectionTitle data-id="element-148" data-mp="3u2673wos5ms8">
        Follow the system <Highlight data-id="element-149" data-mp="lk0893ks3yxl">one category at a time.</Highlight>
      </SectionTitle>
      <SectionLead data-id="element-150" data-mp="qjd4gexjiicu">You do not need to organize the whole house.</SectionLead>

      <ol className="mt-8 grid gap-3 md:grid-cols-4" data-id="element-151" data-mp="qlh6erbvp7ah">
        {usageSteps.map((step, index) => <li key={step.number} className="relative flex flex-col rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" data-id="element-152" data-mp="cpvlowcoh9nv" data-mpi={index}>
            <span className="text-3xl font-black leading-none text-yellow-700" data-id="element-153" data-mp="14i30rscjce05">{step.number}</span>
            <p className="mt-2 text-sm font-black uppercase leading-tight text-blue-950 md:text-base" data-id="element-154" data-mp="19aw4qe06jib6">
              {step.title}
            </p>
            <p className="mt-2 text-sm font-semibold leading-snug text-slate-600" data-id="element-155" data-mp="2rjbgb0uhuelc">{step.text}</p>
            {step.tail && <p className="mt-auto pt-3 text-sm font-black text-blue-950" data-id="element-156" data-mp="31bzfu3cuywnr">{step.tail}</p>}
            {index < usageSteps.length - 1 && <>
                <ArrowRightIcon className="absolute -right-3 top-1/2 hidden h-5 w-5 -translate-y-1/2 text-yellow-700 md:block" aria-hidden="true" data-id="element-157" data-mp="2wixupdm260vq" />
                <ArrowDownIcon className="absolute -bottom-2.5 left-1/2 h-5 w-5 -translate-x-1/2 text-yellow-700 md:hidden" aria-hidden="true" data-id="element-158" data-mp="36cwy0fxvbqp9" />
              </>}
          </li>)}
      </ol>

      <div className="mt-10 rounded-2xl bg-slate-50 p-5 md:p-8" data-id="element-159" data-mp="1pwua0qhfkhzx">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[.16em] text-yellow-700 md:text-sm" data-id="element-160" data-mp="1kxr1gw28rtn7">
          The Complete System
        </p>
        <div className="mt-4 flex flex-wrap items-center justify-center gap-2" data-id="element-161" data-mp="3l1jxys1ff3gd">
          {systemPath.map((stage, index) => <React.Fragment key={stage} data-id="element-162" data-mp="3u0f09t1cntee" data-mpi={index}>
              {index > 0 && <ArrowRightIcon className="h-4 w-4 text-yellow-700" aria-hidden="true" data-id="element-163" data-mp="3u2i2dbfs1czh" />}
              <span className="rounded-lg bg-blue-950 px-3 py-1.5 text-xs font-black uppercase text-white md:text-sm" data-id="element-164" data-mp="2rhqhtxpq739">
                {stage}
              </span>
            </React.Fragment>)}
        </div>
        <p className="mx-auto mt-5 max-w-2xl text-center text-sm font-semibold text-slate-600 md:text-base" data-id="element-165" data-mp="hj0dibozp1w4">
          Clothing + household items + electronics + books + papers + hobbies + memories +
          donations + selling + prevention.
        </p>
        <p className="mt-1 text-center text-sm font-black text-blue-950 md:text-base" data-id="element-166" data-mp="ql9muy8iup7x">
          All organized inside one system.
        </p>

        <p className="mt-6 text-center text-xs font-bold uppercase tracking-wide text-slate-500" data-id="element-167" data-mp="15m6qgkpagioa">
          With every category:
        </p>
        <div className="mt-3 flex flex-wrap items-center justify-center gap-2" data-id="element-168" data-mp="10mllntnftg3n">
          {categoryLoop.map((stage, index) => <React.Fragment key={stage} data-id="element-169" data-mp="vq3njcmm4g0a" data-mpi={index}>
              {index > 0 && <span className="text-sm font-black text-yellow-700" data-id="element-170" data-mp="rnqi6pbs2k41">→</span>}
              <span className={`rounded-lg px-3 py-1.5 text-sm font-black ${index === categoryLoop.length - 1 ? 'bg-amber-400 text-blue-950' : 'bg-white text-blue-950 ring-1 ring-slate-200'}`} data-id="element-171" data-mp="1odhaqj0idx77">
                {stage}
              </span>
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}